module.exports = __webpack_public_path__ + "img/376.71a68bcc.jpg";